import { createAction } from '@reduxjs/toolkit';
import { SET_GLOBAL_SEARCH_TEXT } from '../types';

export const setGlobalSearchText = createAction<
  string,
  typeof SET_GLOBAL_SEARCH_TEXT
>(SET_GLOBAL_SEARCH_TEXT);
